import { render } from "./ProjectSelector.vue?vue&type=template&id=3e90818b&scoped=true"
import script from "./ProjectSelector.vue?vue&type=script&lang=js"
export * from "./ProjectSelector.vue?vue&type=script&lang=js"

import "./ProjectSelector.vue?vue&type=style&index=0&id=3e90818b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e90818b"]])

export default __exports__